export default __webpack_public_path__ + "static/award-05-9e8609d71d9c1b02b1f94b1ed49f0064.png";